import { createContext, useContext, useEffect, useState } from "react";
import { apiMe, clearToken, getStoredUser, getToken, setStoredUser, setToken, apiLogin } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(!!getToken() && !getStoredUser());

  useEffect(() => {
    const token = getToken();
    if (token && !user) {
      apiMe()
        .then((u) => {
          setUser(u);
          setStoredUser(u);
        })
        .catch(() => {
          clearToken();
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, []);

  const login = async (loginId, password) => {
    const res = await apiLogin(loginId, password);
    setToken(res.token);
    setStoredUser(res.user);
    setUser(res.user);
    return res.user;
  };

  const logout = () => {
    clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
